import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FormEventRegistrationService {

  constructor(private http: HttpClient) { }

  toggleShow(uuid: string, sectionId: number, id: number): Observable<any> {
    return this.http.put(`${window.location.origin}/ui-forms/v1/form/submit/${uuid}/registrant/${sectionId}/${id}/show`, null);
  }

  toggleHide(uuid: string, sectionId: number, id: number): Observable<any> {
    return this.http.put(`${window.location.origin}/ui-forms/v1/form/submit/${uuid}/registrant/${sectionId}/${id}/hide`, null);
  }

  removeRegistrant(uuid: string, sectionId: number, id: number): Observable<any> {
    return this.http.delete(`${window.location.origin}/ui-forms/v1/form/submit/${uuid}/registrant/${sectionId}/${id}`);
  }

  refreshRegistrant(uuid: string, sectionId: number, id: number): Observable<any> {
    return this.http.put(`${window.location.origin}/ui-forms/v1/form/submit/${uuid}/registrant/${sectionId}/${id}`, null);
  }

  refreshReservations(uuid: string): Observable<any> {
    return this.http.put(`${window.location.origin}/ui-forms/v1/form/submit/${uuid}/registrant/refreshReservations`, null);
  }

  registerRegistrant(
    uuid: string,
    sectionId: number,
    options: { self?: number; guest?: number; userId?: number } = {}
  ): Observable<any> {
    
    const payload: any = {
      sectionId: sectionId,
      self: options.self ?? 0, // Default to 0
      guest: options.guest ?? 0, // Default to 0
    };

    // Add userId only if provided
    if (options.userId !== undefined) {
      payload.userId = options.userId;
    }

    return this.http.post(`${window.location.origin}/ui-forms/v1/form/submit/${uuid}/registrant/`, payload);
  }
}
